/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { DomainUiLightDto } from './DomainUiLightDto';
import type { TimeZoneDto } from './TimeZoneDto';
import type { UserDomainAggregatedRoleDto } from './UserDomainAggregatedRoleDto';
import type { UserTeamDto } from './UserTeamDto';

export type UserUiDto = {
    aggregatedDomains: Array<UserDomainAggregatedRoleDto>;
    authTypes: Array<'SAML2' | 'LOGIN_PASSWORD'>;
    createdBy?: string;
    domains: Array<DomainUiLightDto>;
    email: string;
    id: string;
    isActive: boolean;
    lastLoginDate?: number;
    name: string;
    resetPassword: boolean;
    role: UserUiDto.role;
    teams: Array<UserTeamDto>;
    timeZoneData?: TimeZoneDto;
    type: UserUiDto.type;
};

export namespace UserUiDto {

    export enum role {
        ADMIN = 'ADMIN',
        SYSTEM_EDITOR = 'SYSTEM_EDITOR',
        SYSTEM_VIEWER = 'SYSTEM_VIEWER',
    }

    export enum type {
        INTERNAL = 'INTERNAL',
        SUPPORT = 'SUPPORT',
    }


}
